export const USER_OS = {
  LINUX: 'Linux',
  MAC: 'Mac',
  UNIX: 'X11',
  WINDOWS: 'Win',
}

export const useOperatingSystem = (): string => {
  if (window.navigator.userAgent.indexOf('Win') !== -1) {
    return USER_OS.WINDOWS
  }
  if (window.navigator.userAgent.indexOf('Mac') !== -1) {
    return USER_OS.MAC
  }
  if (window.navigator.userAgent.indexOf('X11') !== -1) {
    return USER_OS.UNIX
  }
  if (window.navigator.userAgent.indexOf('Linux') !== -1) {
    return USER_OS.LINUX
  }

  return 'Not known'
}
